import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { StepsModule } from 'primeng/steps';
import { CookieConsentComponent } from '../../shared/cookieconsent/cookie-consent.component';
import { LoginSignupComponent } from '../login-signup/login-signup.component';

interface Step {
  icon: string;
}

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    StepsModule,
    TranslocoDirective,
    CardModule,
    ButtonModule,
    LoginSignupComponent,
    CookieConsentComponent,
  ],
})
export class StepperComponent {
  steps: Step[] = [
    { icon: 'user' },
    { icon: 'search' },
    { icon: 'list' },
    { icon: 'favourites' },
    { icon: 'save' },
    { icon: 'smart' },
    { icon: 'warning' },
    { icon: 'stars' },
  ];

  items: MenuItem[] = [
    ...this.steps.map((_, i) => ({
      label: `stepper.steps[${i}].title`,
      command: () => (this.activeIndex = i),
    })),
    {
      label: 'stepper.steps.login.title',
      command: () => (this.activeIndex = this.steps.length),
    },
  ];

  activeIndex = 0;

  firstOpenApp = true;

  constructor() {
    this.firstOpenApp = !!localStorage.getItem('firstOpenApp');

    if (this.firstOpenApp) {
      this.activeIndex = this.steps.length;
    }
  }

  next() {
    if (this.activeIndex < this.steps.length) {
      this.activeIndex++;
      if (this.activeIndex === this.steps.length) {
        localStorage.setItem('firstOpenApp', 'false');
      }
    }
  }

  skip() {
    this.activeIndex = this.steps.length;
    localStorage.setItem('firstOpenApp', 'false');
  }
}
